
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/sub/developer-tools",
      function () {
        return require("private-next-pages/us/sub/developer-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/sub/developer-tools"])
      });
    }
  